import { SAVE_USER_DATA, SESSION_EXPIRE, USER_LOGOUT, EDIT_USER_DATA } from "../actions/types";

export function UserReducer(state = {}, action) {
  const { type, payload } = action;

  switch (type) {
    case SAVE_USER_DATA:
      return {
        ...state,
        user: payload.user,
        token: payload.token,
        type: payload.type,
        session_expired: false,
      };
    case EDIT_USER_DATA:
      // console.log("payload.user", payload.user);
      return {
        ...state,
        user: payload.user,
      };
    case SESSION_EXPIRE:
      return {
        ...state,
        session_expired: true,
      };
    case USER_LOGOUT:
      state = {};
      return {
        ...state,
      };
    default:
      return state;
  }
}
